<template>
  <div class="mt-5">
    <vx-card class="no-scroll-content" title="MasterFile Upload">
      <div class="mb-8">
        <ImportExcelwithsheet :onSuccess="loadDataInTable" />
      </div>
      <vs-tabs v-model="activeTab" v-if="sheetsData.length" alignment="fixed">
        <vs-tab
          v-for="(sheet, index) in sheetsData"
          :key="index"
          :label="standardHeaders[index]"
        >
          <div class="tab-content">
            <vs-table
              stripe
              pagination
              :max-items="10"
              search
              :data="sheet.results"
            >
              <template slot="header">
                <h4>{{ standardHeaders[index] }}</h4>
              </template>

              <template slot="thead">
                <vs-th
                  :sort-key="heading"
                  v-for="heading in sheet.header"
                  :key="heading"
                >
                  {{ heading }}
                </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td
                    :data="col"
                    v-for="(col, indexcol) in tr"
                    :key="indexcol + col"
                  >
                    {{ col }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <div class="footer">
              <vs-button
                @click="uploadData"
                color="success"
                type="filled"
                icon-pack="feather"
                icon="icon-upload"
              >
                Upload
              </vs-button>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import { FormWizard } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";

import moment from "moment";
import vSelect from "vue-select";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import ImportExcelwithsheet from "@/components/excel/ImportExcelwithsheet.vue";
import VxCard from "../../components/vx-card/VxCard.vue";

export default {
  data() {
    return {
      activeTab: 0,
      sheetsData: [],
      standardHeaders: [
        "AspnetUsers/Users",
        "Employee Information",
        "Employee Identification",
        "Employee Salary",
        "Employee Salary Information",
      ],
    };
  },
  methods: {
    loadDataInTable(sheetData) {
      this.sheetsData = sheetData;
    },
    uploadData() {
      // Placeholder for upload logic
      console.log("Uploading data...");
    },
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    flatPickr,
    ImportExcelwithsheet,
    VxCard,
  },
};
</script>

<style>
/* Custom styles to ensure proper layout */
.tab-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.vs-table {
  flex: 1;
}

.footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 0;
}
</style>
